import { defineStore } from "pinia";
import { i18n } from "/@/i18n";

export const localesStore = defineStore("app", {
  state: () => {
    return {
      locale: localStorage.getItem("lang") || "zh_cn",
    };
  },
  actions: {
    SET_LOCALE(locale: any) {
      console.log(locale);
      this.locale = locale;
      localStorage.setItem("lang", locale);
      i18n.global.locale.value = locale;
    },
  },
  getters: {
    // 获取 sessionId
    getLocale(state): string {
      return state.locale; // 明确返回类型为 string
    },
  },
});
